export const INCOMPLETE_STUDENT_FLAG = "(Incomplete)";

/**
 * Type of a Student as fetched from the legacy API.
 */

export interface AcademyStudent {
	userId: string;
	platformId: string;
	firstName: string;
	lastName: string;
	campusId?: string;
	grade?: number;
}

export interface UninitializedStudent {
	platformId: string;
	firstName?: string;
	lastName?: string;
	displayName: string;
}

export interface StudentsByApp {
	academyStudents: AcademyStudent[];
	platformStudents: UninitializedStudent[];
}
